import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {productionLoadDto} from './defaultResponseModel/productionLoad';
const FUNCTION_CODE = 'GET_PRODUCTION_LOAD';

export async function getProductionLoad(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/codev/production-load-das/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return productionLoadDto.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
